export default __webpack_public_path__ + "static/media/notification.b1acaf61.svg";